import type { EmployeeLookup } from '../model/types'
import { LastDayBadge } from './LastDayBadge'

function personSubtitle(
  person: Pick<EmployeeLookup, 'employeeCode' | 'email' | 'mobileNumber'>,
): string {
  return [person.employeeCode, person.email, person.mobileNumber].filter(Boolean).join(' · ')
}

export function PersonOption({ person }: { person: EmployeeLookup }) {
  const subtitle = personSubtitle(person)
  return (
    <div className="flex flex-col">
      <span className="flex items-center gap-2">
        <span>
          {person.firstName} {person.lastName}
        </span>
        <LastDayBadge lastDayWorked={person.lastDayWorked} />
      </span>
      {subtitle && (
        <span className="text-xs text-muted-foreground">{subtitle}</span>
      )}
    </div>
  )
}
